import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";
import {BettingAdPromotionApiModel} from "./betting-ad.promotion.api-model";

export class BettingAdPromotionDomainModel extends BaseDomainModel {
  apiModel: BettingAdPromotionApiModel;

  constructor(apiModel: BettingAdPromotionApiModel) {
    super(apiModel);

    this.imageUrl = apiModel.image_url;
    this.bookmakerId = apiModel.bmid;
    this.stars = apiModel.stars;
    this.rank = apiModel.rank;
    this.titles = apiModel.titles;
    this.ctaTitle = apiModel.cta_title;
    this._link = apiModel.link;
  }

  get link(): String {
    const links = {
      14: "https://www.bet365.com/olp/open-account?affiliate=365_02896552",
      47: "https://gml-grp.com/C.ashx?btag=a_12523b_1246c_&affid=3532&siteid=12523&adid=1246&c=Context-BWP_Platform_OS-Web_$GUID",
      139: "https://promo.sportingbet.com/pt-br/promo/p/sports/latam/bonus-apostas-esportivas-boas-vindas?trackerId=5387330&tdpeh=Context-BWP_Platform_OS-Web_$GUID_ga4clientid-$GA_CLIENT_ga4sessionidRLK-$GA4_SESSION&btag=301645",
    }

    const link = links[this.bookmakerId] || this._link;

    return link;
  }
}
